module.exports = __webpack_public_path__ + "static/media/marker_plant_icon.fb567c78.svg";